import Link from "next/link";
import useSound from "use-sound";
interface CustomButtonProps {
    cta?: string;
    href?: string;
    type?: string;
    onClick?: any;
    icon?: "replay" | "next";
    displayType?: "normal" | "white" | "gray" | "none";
    size?: "small" | "medium" | "large";
    shadow?: boolean;
    fill?: "solid" | "border";
    playSound?: boolean;
}

export const CustomButton: React.FC<CustomButtonProps> = ({
    cta = "Play",
    href = "/",
    type = "link",
    onClick,
    icon = "",
    displayType = "normal",
    size = "large",
    shadow = true,
    fill = "solid",
    playSound = true,
}) => {
    const [play] = useSound("/assets/sounds/Button Click Sound.mp3");

    let className =
        "flex flex-row items-center justify-center w-full text-lg font-semibold rounded-lg cursor-pointer h-14 z-10" +
        " ";

    switch (size) {
        case "large":
            className =
                "flex flex-row items-center justify-center w-full text-lg font-semibold rounded-lg cursor-pointer h-14 z-10" +
                " ";
            break;
        case "medium":
            // to do
            break;
        case "small":
            className =
                "flex flex-row items-center justify-center w-full text-base font-normal rounded-lg cursor-pointer h-10 z-10" +
                " ";
    }

    className =
        className +
        (displayType === "white"
            ? "bg-white text-dark-purple"
            : displayType === "gray"
            ? "bg-gray-x11 text-white " + (shadow ? "shadow-md" : "")
            : displayType === "none"
            ? "text-dark-purple"
            : "text-dark-purple " +
              (shadow ? "shadow-md" : "") +
              " " +
              (fill == "solid"
                  ? "bg-gargoyle-gas"
                  : "border-2 border-solid border-gargoyle-gas"));

    const Icon = () => (
        <div className="w-8 h-8 mr-2 rounded-full ">
            <img
                src={
                    icon === "next"
                        ? "/assets/images/collection-next.png"
                        : "/assets/images/collection-replay.png"
                }
                alt="coin"
                className="object-contain w-full h-full"
            />
        </div>
    );

    if (type == "link")
        return (
            <Link href={href}>
                <div
                    className={className}
                    onClick={() => {
                        if (playSound) {
                            play();
                        }
                        if (onClick) onClick();
                    }}
                >
                    {icon && <Icon />}
                    {cta}
                </div>
            </Link>
        );
    else if (type == "submit")
        return (
            <button type="submit" className={className} onClick={play}>
                {icon && <Icon />}
                {cta}
            </button>
        );
    else if (type == "action")
        return (
            <button
                onClick={() => {
                    if (playSound) {
                        play();
                    }
                    onClick();
                }}
                className={className}
            >
                {icon && <Icon />}
                {cta}
            </button>
        );
    else
        return (
            <div className={className} onClick={play}>
                {icon && <Icon />}
                {cta}
            </div>
        );
};
